var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2136_6310"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2136_6310)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,4C7.54286,4,4,7.54286,4,12C4,16.4571,7.54286,20,12,20C16.4571,20,20,16.4571,20,12C20,7.54286,16.4571,4,12,4ZM15.2,15.2001C15.8858,15.2001,16.4572,15.6573,16.6858,16.343C17.7143,15.2001,18.4,13.71439,18.4,12.00011C18.4,9.257249999999999,16.8,6.97154,14.4,6.05725L14.4,6.40011C14.4,7.3143899999999995,13.71433,8.00011,12.80005,8.00011L11.200050000000001,8.00011L11.200050000000001,9.60011C11.200050000000001,10.05725,10.85719,10.40011,10.40005,10.40011L8.800049999999999,10.40011L8.800049999999999,12.00011L13.60005,12.00011C14.0572,12.00011,14.4,12.34297,14.4,12.80011L14.4,15.2001L15.2,15.2001ZM11.200099999999999,18.4C8.0001,17.9429,5.6001,15.3143,5.6001,12C5.6001,11.54285,5.71438,10.97143,5.71438,10.51428L9.600100000000001,14.4L9.600100000000001,15.2C9.600100000000001,16.1143,10.28581,16.8,11.200099999999999,16.8L11.200099999999999,18.4Z",
    fillRule: "evenodd",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocale);
export default __webpack_public_path__ + "static/media/locale.45ff7cedbc97128931802c999b2467bc.svg";
export { ForwardRef as ReactComponent };